import { useRecoilState } from "recoil";
import { productKeyAtom } from "src/atoms";

// WrapsodyEco사이트인지 파악
export const useIsWrapsodyEcoProduct = () => {
  const [productKey, setProductKey] = useRecoilState(productKeyAtom);

  return { isWrapsodyEco: productKey === "WRAPSODY_ECO" };
};
